






import Vue from 'vue'
import { Signification } from '../models/Signification';
import { User } from '../models/User';

export default Vue.extend({
    name: 'SignificationInformations',
    props: {
        signification: Signification
    },
    data() {
        return {
            bailiff: null as User
        }
    },
    mounted() {
        this.signification.getBailiff()
            .then(b => this.bailiff = b);
    }
})
